import apiClient from '@/api/client';

// ─── Geführter Rundgang ──────────────────────────────────────────────────────
//
// Der Server entscheidet, was ansteht – nicht das Frontend. Nur er weiß, was
// dieses Konto schon gesehen hat und welche Funktionen seit dem letzten Mal
// dazugekommen sind.

export type Rundgang = 'start' | 'funktionen';

export interface RundgangStand {
  /** Was jetzt ansteht – null heißt: nichts. */
  offen: Rundgang | null;
  /** Funktionsschlüssel, die dabei gezeigt werden sollen. */
  neu: string[];
  /** Was schon erledigt ist – für „nochmal zeigen". */
  erledigt: Rundgang[];
}

export async function ladeRundgang(): Promise<RundgangStand> {
  const { data } = await apiClient.get<RundgangStand>('/rundgang');
  return data;
}

/** Abschließen und Überspringen laufen hier zusammen – siehe Backend. */
export async function rundgangErledigt(rundgang: Rundgang, funktionen: string[]): Promise<void> {
  await apiClient.post('/rundgang/erledigt', { rundgang, funktionen });
}

export async function rundgangNochmal(): Promise<RundgangStand> {
  const { data } = await apiClient.post<RundgangStand>('/rundgang/nochmal');
  return data;
}
